
//   document.addEventListener("click", function (e) {
//   const button = e.target.closest("#load-more-btn");
//   if (!button) return;

//   let nextUrl = button.getAttribute("data-next-url");
//   if (!nextUrl) return;

//   button.innerText = "Loading...";
//   button.disabled = true;

//   fetch(nextUrl + "&section_id=main-collection-product-grid", {
//     headers: { "X-Requested-With": "XMLHttpRequest" }
//   })
//     .then((res) => res.text())
//     .then((html) => {
//       const temp = document.createElement("div");
//       temp.innerHTML = html;

//       const newGrid = temp.querySelector("#product-grid");
//       const currentGrid = document.querySelector("#product-grid");

//       if (newGrid && currentGrid) {
//         currentGrid.insertAdjacentHTML("beforeend", newGrid.innerHTML);
//       }

//       const newButton = temp.querySelector("#load-more-btn");

//       if (newButton) {
//         button.setAttribute(
//           "data-next-url",
//           newButton.getAttribute("data-next-url")
//         );
//         button.innerText = "Load More";
//         button.disabled = false;
//       } else {
//         button.remove();
//       }
//     })
//     .catch(() => {
//       button.innerText = "Error";
//     });
// });


document.addEventListener("click", function (e) {
  const button = e.target.closest("#load-more-btn");
  if (!button) return;

  let nextUrl = button.getAttribute("data-next-url");
  if (!nextUrl) return;

  button.innerText = "Loading...";
  button.disabled = true;

  fetch(nextUrl, { headers: { "X-Requested-With": "XMLHttpRequest" } })
    .then((res) => res.text())
    .then((html) => {
      const temp = document.createElement("div");
      temp.innerHTML = html;

      const newGrid = temp.querySelector("#product-grid");
      const currentGrid = document.querySelector("#product-grid");

      if (newGrid && currentGrid) {
        const newProducts = newGrid.querySelectorAll(".grid__item");
        newProducts.forEach((item) => currentGrid.appendChild(item));
      }

      const newButton = temp.querySelector("#load-more-btn");

      if (newButton) {
        button.setAttribute(
          "data-next-url",
          newButton.getAttribute("data-next-url")
        );
        button.innerText = "Load More";
        button.disabled = false;
      } else {
        button.remove();
      }
    })
    .catch(() => {
      button.innerText = "Error";
    });
});